import { z } from 'zod'

export const BooleanDtoSchema = z.boolean()

export type BooleanDto = z.infer<typeof BooleanDtoSchema>
